import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-0 left-0 z-[100]! flex flex-nowrap items-end justify-center w-full md:hidden bg-[linear-gradient(0deg,rgba(0,0,0,1)0%,rgba(0,0,0,0.66)52%,rgba(0,0,0,0)100%)]"
}
const _hoisted_2 = {
  key: 1,
  class: "fixed bottom-0 left-0 z-[100]! grid grid-cols-5 items-end justify-center w-full md:hidden bg-[linear-gradient(0deg,rgba(0,0,0,1)0%,rgba(0,0,0,0.66)52%,rgba(0,0,0,0)100%)]"
}

export function render(_ctx, _cache) {
  return (!_ctx.auth.isLoggedIn)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        _createElementVNode("li", {
          onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.btnClickRegister && _ctx.btnClickRegister(...args))),
          class: "cursor-pointer",
          title: "register"
        }, _cache[8] || (_cache[8] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/btn-main-register.webp",
            alt: "register"
          }, null, -1 /* HOISTED */)
        ])),
        _createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.btnClickGame && _ctx.btnClickGame(...args))),
          class: "cursor-pointer relative -bottom-3",
          title: "play"
        }, _cache[9] || (_cache[9] = [
          _createElementVNode("img", {
            class: "max-w-28",
            src: "https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/btn-main-play-mobile.webp",
            alt: "play"
          }, null, -1 /* HOISTED */)
        ])),
        _createElementVNode("li", {
          onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.btnClickContact && _ctx.btnClickContact(...args))),
          class: "cursor-pointer",
          title: "support"
        }, _cache[10] || (_cache[10] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/btn-main-contact.webp",
            alt: "support"
          }, null, -1 /* HOISTED */)
        ]))
      ]))
    : (_openBlock(), _createElementBlock("ul", _hoisted_2, [
        _createElementVNode("li", {
          onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.btnClickProfile && _ctx.btnClickProfile(...args))),
          class: "cursor-pointer",
          title: ""
        }, _cache[11] || (_cache[11] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn-my-profile-new.webp",
            alt: ""
          }, null, -1 /* HOISTED */)
        ])),
        _createElementVNode("li", {
          onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.btnClickWallet && _ctx.btnClickWallet(...args))),
          class: "cursor-pointer",
          title: ""
        }, _cache[12] || (_cache[12] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn-my-wallet-new.webp",
            alt: ""
          }, null, -1 /* HOISTED */)
        ])),
        _createElementVNode("li", {
          onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.btnClickPromotion && _ctx.btnClickPromotion(...args))),
          class: "cursor-pointer",
          title: ""
        }, _cache[13] || (_cache[13] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn-my-promotion.webp",
            alt: ""
          }, null, -1 /* HOISTED */)
        ])),
        _createElementVNode("li", {
          onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.btnClickAffiliate && _ctx.btnClickAffiliate(...args))),
          class: "cursor-pointer",
          title: ""
        }, _cache[14] || (_cache[14] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn-my-affiliate.webp",
            alt: ""
          }, null, -1 /* HOISTED */)
        ])),
        _createElementVNode("li", {
          onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.btnClickContact && _ctx.btnClickContact(...args))),
          class: "cursor-pointer",
          title: ""
        }, _cache[15] || (_cache[15] = [
          _createElementVNode("img", {
            class: "w-full",
            src: "https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/btn-my-contact_result.webp",
            alt: ""
          }, null, -1 /* HOISTED */)
        ]))
      ]))
}